import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="twofactor"
export default class extends Controller {
  // Define targets for this controller
  static targets = [
    "smsContent", "authenticatorContent", "passkeyContent", 
    "recoveryCodeForm", "recoveryCodeOption",
    "authenticationCodeForm", "passkeyOption", "smsOption", "authenticatorOption"
  ];
  static values = {
    selectedMethod: String,
    configuredMethods: { type: Array, default: [] }
  }

  connect() {
  }

  updateOptions() {
    switch (this.selectedMethodValue) {
      case "sms":
        this.toggleVisibility("recoveryCodeOption", "hidden", false);                
        this.toggleVisibility("smsOption", "hidden", true);
        this.toggleVisibility("passkeyOption", "hidden", false);
        this.toggleVisibility("authenticatorOption", "hidden", false);
        break;
      case "authenticator":
        this.toggleVisibility("recoveryCodeOption", "hidden", false);        
        this.toggleVisibility("smsOption", "hidden", false);
        this.toggleVisibility("passkeyOption", "hidden", false);
        this.toggleVisibility("authenticatorOption", "hidden", true);
        break;
      case "passkey":
        this.toggleVisibility("recoveryCodeOption", "hidden", false);        
        this.toggleVisibility("smsOption", "hidden", false);
        this.toggleVisibility("passkeyOption", "hidden", true);
        this.toggleVisibility("authenticatorOption", "hidden", false);
        break;
      case "recoveryCode":
        this.toggleVisibility("recoveryCodeOption", "hidden", true);
        this.toggleVisibility("smsOption", "hidden", false);
        this.toggleVisibility("passkeyOption", "hidden", false);
        this.toggleVisibility("authenticatorOption", "hidden", false);
        break;        
    }
  }

  showPasskey(event) {
    event.preventDefault();    
    this.selectedMethodValue = "passkey";
    this.toggleVisibility("recoveryCodeForm", "hidden", true);    
    this.toggleVisibility("authenticationCodeForm", "hidden", true);
    this.toggleVisibility("smsContent", "hidden", true);
    this.toggleVisibility("authenticatorContent", "hidden", true);
    this.toggleVisibility("passkeyContent", "hidden", false);
    this.updateOptions();
  }
  
  showRecoveryCode(event) {
    event.preventDefault();
    this.selectedMethodValue = "recoveryCode";
    this.toggleVisibility("recoveryCodeForm", "hidden", false);    
    this.toggleVisibility("authenticationCodeForm", "hidden", true);
    this.toggleVisibility("passkeyContent", "hidden", true);
    this.toggleVisibility("smsContent", "hidden", true);
    this.toggleVisibility("authenticatorContent", "hidden", true);
    this.updateOptions();    
  }

  showAuthenticator(event) {
    event.preventDefault();
    this.selectedMethodValue = "authenticator";
    this.toggleVisibility("recoveryCodeForm", "hidden", true);
    this.toggleVisibility("authenticationCodeForm", "hidden", false);
    this.toggleVisibility("passkeyContent", "hidden", true);
    this.toggleVisibility("smsContent", "hidden", true);
    this.toggleVisibility("authenticatorContent", "hidden", false);
    this.updateOptions();
  }

  sendSmsCode(event) {
    event.preventDefault();
    this.selectedMethodValue = "sms";
    this.showAuthenticatorForm();
    this.toggleVisibility("recoveryCodeForm", "hidden", true);    
    this.toggleVisibility("authenticatorContent", "hidden", true);
    this.toggleVisibility("passkeyContent", "hidden", true);
    this.toggleVisibility("smsContent", "hidden", false);
    this.updateOptions();

    fetch('/sms', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name=csrf-token]').content,
      }
    })
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .catch((error) => {
      alert("There was a problem: " + error.message);
    });
  }

  showAuthenticatorForm() {
    this.toggleVisibility("authenticationCodeForm", "hidden", false);
  }

  // Helper method to toggle visibility of a target if it exists
  toggleVisibility(targetName, className, add) {
    if (this[`has${this.capitalize(targetName)}Target`]) {
      if (add) {
        this[`${targetName}Target`].classList.add(className);
      } else {
        this[`${targetName}Target`].classList.remove(className);
      }
    }
  }

  // Capitalizes the first letter of a string (e.g., "smsContent" => "SmsContent")
  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}